import React from 'react';
import {Button, Typography} from "@mui/material";
import Div from "@jumbo/shared/Div";

const MobileButton = ({ 
    sx, 
    btnText,
    size,
    onClick,
    preset,
    isGrey=false,
    btnStyle,
    disabled=false
}) => {
    
    return (
        <Div sx={{
            position: 'relative',
            width: '100%',
            ...sx
        }}>
          <Button
            onClick={onClick}
            variant="contained"
            disabled={disabled}
            disableElevation
            fullWidth = {size == 'small' ? false : true}
            sx={preset == "round" ? 
              {
                height: size == 'small' ? '32' : '40px',
                backgroundColor: '#C21B17',
                borderRadius: '20px',
                textTransform: 'unset',
                fontSize: 12,
                ... btnStyle,

                '&.MuiButtonBase-root:hover' : {
                  backgroundColor: '#B31A16'
                }
              } : preset == "secondaryRound" ? 
              {
                height: size == 'small' ? '33px' : '40px',
                backgroundColor: '#ffffff',
                border: "1px solid #C21B17",
                borderRadius: '20px',
                textTransform: 'unset',
                fontSize: 12,
                color: '#C21B17',
                ... btnStyle,

                '&.MuiButtonBase-root:hover' : {
                  backgroundColor: '#e9e9e9'
                }
              } :
              {
                height: '52px',
                backgroundColor: (isGrey?'#f3f3f3':'#C21B17'),
                borderRadius: '10px',
                textTransform: 'unset',
                fontSize: 16,
                ... btnStyle,
                color:(isGrey?'#475259':'#fff'),
                border:(isGrey?'1px solid #eee':'none'),
                '&.MuiButtonBase-root:hover' : {
                  backgroundColor: (isGrey?'#F6F6F6':'#B31A16')
                }
              }
          }
          >
            {btnText}
          </Button>
        </Div>
    );
};

export default MobileButton;
